import * as React from "react";
import { cls_link_default, cls_link_nostyle } from "./link.css";
import { join } from "../helpers";
import { Link as WouterLink } from "wouter";
export var Link = function (props) {
    var cls = join(cls_link_nostyle, props.className);
    var target = props.targetBlank === true ? "_blank" : "_self";
    return props.routesOutOfThisWeb ? React.createElement("a", { href: props.url, className: cls, target: target }, props.children) : React.createElement(WouterLink, { href: props.url, onClick: props.onClickIfLocal },
        React.createElement("a", { className: cls, target: target }, props.children));
};
export var TextLink = function (props) {
    var cls = join(cls_link_default, props.className);
    var target = props.targetBlank === true ? "_blank" : "_self";
    return props.routesOutOfThisWeb ? React.createElement("a", { href: props.url, className: cls, target: target }, props.children) : React.createElement(WouterLink, { href: props.url, onClick: props.onClickIfLocal },
        React.createElement("a", { className: cls, target: target }, props.children));
};
